import React from "react";
import PropTypes from "prop-types";
import MuiButton from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import "./Button.scss";
import BubbleLoader from "components/BubbleLoader";
import { getPaletteColor } from "utils";
const Button = ({
  children,
  text,
  onClick,
  disabled,
  isLoading,
  type,
  className,
  height,
}) => {
  const {
    primaryColor,
    secondaryColor,
    buttonBorderRadius,
    buttonTextPrimary,
    buttonTextSecondary,
    buttonBorderSecondary,
    buttonBorder,
  } = getPaletteColor();
  const handleClick = (e) => {
    if (!isLoading && !disabled && typeof onClick === "function") {
      onClick(e);
    }
  };
  const buttonStyles = (type) => {
    switch (type) {
      case "black-white": {
        return {
          background: primaryColor,
          border: disabled ? "none" : `1px solid ${buttonBorder}`,
          color: buttonTextPrimary,
          borderRadius: buttonBorderRadius,
        };
      }
      case "white-black": {
        return {
          background: "#EEEEEE",
          color: primaryColor,
          border: disabled ? "none" : `1px solid ${buttonBorder}`,
          borderRadius: buttonBorderRadius,
        };
      }
      case "primary": {
        return {
          background: primaryColor,
          border: disabled ? "none" : `1px solid ${buttonBorder}`,
          color: buttonTextPrimary,
          borderRadius: buttonBorderRadius,
        };
      }
      case "secondary": {
        return {
          background: secondaryColor,
          border: `1px solid ${buttonBorderSecondary}`,
          color: buttonTextSecondary,
          borderRadius: buttonBorderRadius,
        };
      }
      default: {
        return {
          background: primaryColor,
          border: disabled ? "none" : `1px solid ${buttonBorder}`,
          color: buttonTextPrimary,
          borderRadius: buttonBorderRadius,
        };
      }
    }
  };
  const { background, color, border, borderRadius } = buttonStyles(type);
  const StyledMuiButton = styled(MuiButton)({
    boxShadow: "none",
    textTransform: "none",
    backgroundColor: background,
    color: color,
    border: border,
    borderRadius: borderRadius,
    padding: "0em",
    margin: "0",
    minHeight: "2.2rem",
    height: height || "auto",
    "&:hover": {
      backgroundColor: background,
      border: border,
      boxShadow: "none",
    },
    "&:active": {
      backgroundColor: background,
      border: border,
      boxShadow: "none",
    },
    "&:focus": {
      backgroundColor: background,
      border: border,
      boxShadow: "none",
    },
  });

  return (
    <div className={`Button__Container`}>
      <StyledMuiButton
        className={`${className} Button ${type} ${disabled && "gray"} `}
        onClick={handleClick}
        disabled={disabled}
      >
        {isLoading ? (
          <BubbleLoader color={color} />
        ) : (
          <>{children || text || "Submit"}</>
        )}
      </StyledMuiButton>
    </div>
  );
};

Button.propTypes = {
  children: PropTypes.any,
  type: PropTypes.oneOf([
    "yellow-black",
    "grey-white",
    "blue-white",
    "gray-blue",
    "white-blue",
    "black-white",
    "white-black",
    "google",
    "primary",
    "secondary",
  ]),
  text: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
};
Button.defaultProps = {
  children: null,
  type: "primary",
  text: "Submit",
  onClick: () => {},
  disabled: false,
  isLoading: false,
  className: "",
};

export default Button;
